import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=2e24f7a3&lang=pug"
import script from "./Insights.vue?vue&type=script&lang=ts"
export * from "./Insights.vue?vue&type=script&lang=ts"
import style0 from "./Insights.vue?vue&type=style&index=0&id=2e24f7a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports